import { Experiments } from 'CustomOptimizelyProvider'

interface RCEVoucherAudienceFlags {
  isSalableCustomer: boolean
  isAcceptedCustomer: boolean
}

export const getRCEVoucherExperiment = ({
  isSalableCustomer,
  isAcceptedCustomer
}: RCEVoucherAudienceFlags): Experiments | null => {
  if (isSalableCustomer) {
    return Experiments.CAT_4558_RCE_SMAVA_VOUCHER_SALABLE
  }

  if (isAcceptedCustomer) {
    return Experiments.CAT_4558_RCE_SMAVA_VOUCHER_ACCEPTED
  }

  return null
}
